<template lang="pug">
    include Lopd.pug
</template>

<script>
import Api from "@/components/services/Api";

export default {
    name: 'Lopd',
    computed: {
        isValid: function() {
            return (this.chk1 && this.chk2);
        }
    },
    data() {
        return {
            chk1: false,
            chk2: false,
        };
    },
    methods: {
        send() {
            const _this = this;

            Api.lopd(this.$store.state.token).then(() => {
                _this.$router.push({
                    name: "DashboardIndex",
                });
            }).catch();
        }
    }
}

</script>

<style scoped lang="scss">
@import "Lopd";
</style>



// WEBPACK FOOTER //
// src/components/lopd/Lopd.vue